/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {previewShiftSchedule} from '../api'

export const useMutationPreviewShiftSchedule = createReactQueryMutationHook('previewShiftSchedule', previewShiftSchedule)
